import { createContext, useContext } from 'react';
import { T } from './tokens';

export interface Theme {
  accent: string;
  radius: number;
  density: 'kompakt' | 'luftig';
}

/** Faste produktionsværdier (design-prototypens TweaksPanel er fjernet). */
export const THEME: Theme = { accent: T.accent, radius: 12, density: 'luftig' };

export const ThemeCtx = createContext<Theme>(THEME);
export const useTheme = (): Theme => useContext(ThemeCtx);

export interface Density { pad: number; gap: number; row: number }
export const dens = (t: Theme): Density =>
  t.density !== 'kompakt' ? { pad: 18, gap: 14, row: 14 } : { pad: 13, gap: 10, row: 10 };
